import React, { useEffect, useState } from "react";
import Home from "./Pages/Home";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import GoToTop from "./Components/Helper/GoToTop";
// import CommingSoon from "./Pages/CommingSoon";
import PageTitles from "./Components/Helper/PageTitles";
import NotMatch from "./Pages/NotMatch";
import { ModalError } from "./Components/ModalError";
// import { BaseData } from "./Data/BaseData";
import { CenterLoading } from "./Components/CenterLoading";

function App() {
  const [pageHeight] = useState(window.innerHeight);
  const [scroll, setScrollState] = useState(0);
  const [errors, setErrors] = useState({});
  const [loading, setLoading] = useState(true);
  const [BaseData, setBaseData] = useState({});
  const [loadingIndex, setLoadingIndex] = useState(true);
  const [indexData, setIndexData] = useState({});

  function updateError({ text, time, type }) {
    setErrors({
      text: text,
      time: time,
      type: type,
    });
  }
  useEffect(() => {
    async function fetchData () {
      let data = await fetch('/data/main.json');
      if(data.status === 200){
        let newbasedata = JSON.parse(await data.text())
        setBaseData(newbasedata)
        setLoading(false);
      }
    }
    async function fetchDataPageIndex () {
      let data = await fetch('/data/index-pages.json');
      if(data.status === 200){
        setIndexData(JSON.parse(await data.text()))
        setLoadingIndex(false);
      }
    }
    fetchData();
    fetchDataPageIndex()
    document.addEventListener('scroll', setScroll);
    return () => {
        document.removeEventListener('scroll', setScroll);
    }
    // eslint-disable-next-line
  }, []);
  const setScroll = (e) => {
    setScrollState(window.scrollY)
  }

  if(loading || loadingIndex){
    return (
      <CenterLoading/>
    )
  }



  return (
    <BrowserRouter>
      <GoToTop/>
      <PageTitles pages={BaseData.pages} PageIndex={indexData} base={'Faraz Andishan'}/>
      <Routes>
        <Route 
          exact={false} 
          path="/*" 
          element={
            <Home 
              pageHeight={pageHeight} 
              BaseData={BaseData} 
              PageIndex={indexData} 
              scroll={scroll}
            />
          } 
        />
        <Route path="*" element={<NotMatch/>} BaseData={BaseData} PageIndex={indexData}/>
      </Routes>
      <ModalError errors={errors} updateError={updateError} />
    </BrowserRouter>
  );
}

export default App;
